export default __webpack_public_path__ + "media/zurb/img/playground/formulas-icon-2787ba121d05390e66d52242dc1df5b6.png";